{
  "id": "campaign-143",
  "name": "Willow Vale",
  "seed": "campaign:143",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "T........mmm.hm..#",
    "..T..T....m..m.m..",
    "..............m...",
    "...h......#...h...",
    ".h................",
    "....x....,..T.....",
    "........,.,.......",
    "www+w....,....wwww",
    "w...www..wwww+w...",
    "......ww+w........",
    ".T................",
    "...............#..",
    "............T.....",
    ".................T",
    "..Y...............",
    "...........h......",
    ".........h....#...",
    ".................S"
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 17,
      "y": 2
    },
    {
      "kind": "deer",
      "x": 17,
      "y": 3
    },
    {
      "kind": "stag",
      "x": 7,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 8,
      "y": 16
    },
    {
      "kind": "deer",
      "x": 8,
      "y": 15
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 17
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 6,
      "y": 1,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 143,
  "biome": "meadow",
  "par": {
    "reel": 10940,
    "push": 9257,
    "selfPropelled": 8688,
    "tractor": 7349,
    "zeroTurn": 6373,
    "fairway": 4170
  },
  "goldTime": {
    "reel": 10940,
    "push": 9257,
    "selfPropelled": 8688,
    "tractor": 7349,
    "zeroTurn": 6373,
    "fairway": 3875
  },
  "routeTries": {
    "par": {
      "reel": 20,
      "push": 19,
      "selfPropelled": 8,
      "tractor": 9,
      "zeroTurn": 7,
      "fairway": 9
    },
    "gold": {
      "reel": 20,
      "push": 19,
      "selfPropelled": 8,
      "tractor": 9,
      "zeroTurn": 7,
      "fairway": 39
    }
  }
}
